var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"formBtn"},[_c('b-button',{attrs:{"id":"submitBtn","disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.$t(_vm.localeConsts.submitButton))+" ")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }